import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Row from "react-bootstrap/Row";
import AxisSpinner from "../components/AxisSpinner";
import { PageTitleController } from "../components/PageTitleController";
import {
  BsBuildingFillAdd,
  BsCashCoin,
  BsEnvelopeFill,
  BsGeoAltFill,
  BsTelephoneFill,
} from "react-icons/bs";
import { AddEditFacilityModal } from "../modals/AddEditFacilityModal";
import { TrustInvoiceSettingsModal } from "../modals/TrustInvoiceSettingsModal";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { isAdminRole } from "../util/Permissions";

const DisplayFacilities = () => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [trusts, setTrusts] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [trust, setTrust] = useState(null);
  const [facility, setFacility] = useState(null);
  const [showAddFacilityModel, setShowAddFacilityModel] = useState(false);
  const [showInvoiceSettings, setShowInvoiceSettings] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    document.title = "Facilities";
    getTrusts();
    fetchCurrentUser();
  }, []);

  useEffect(() => {
    getFacilities();
  }, [trust]);


  const fetchCurrentUser = async () => {
    try {
      const response = await authAxios().get("/api/backoffice/users/current_user");
      setUserRole(response?.data?.role || null);
    } catch (error) {
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const getTrusts = async () => {
    let isMounted = true;
    try {
      const response = await authAxios().get("/api/trusts/");
      if (isMounted) {
        setTrusts(response.data);

        if (!trust && response.data.length > 0) {
          setTrust(response.data[0]);
        }
      }
    } catch (error) {
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
    return () => (isMounted = false);
  };

  const getFacilities = async () => {
    let isMounted = true;
    try {
      setLoading(true);

      var params = {};
      if (trust !== null && trust !== undefined) {
        params["trust_id"] = trust?.id;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/facilities/all",
        null,
        config,
      );
      if (isMounted) {
        setFacilities(response.data);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
    return () => (isMounted = false);
  };

  const facilityTable = () => {
    return (
      <Fragment>
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>Email</th>
              <th>Phone</th>
            </tr>
          </thead>
          <tbody>
            {facilities?.map((f, index) => (
              <tr
                key={f?.id}
                onClick={() => {
                  setFacility(f);
                  setShowAddFacilityModel(true);
                }}
              >
                <td>{f?.name}</td>
                <td>{f?.address}</td>
                <td>{f?.email}</td>
                <td>{f?.phone}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Fragment>
    );
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;
    return <Fragment>{facilityTable()}</Fragment>;
  };

  const updateTrustSettings = (updatedTrust) => {
    setShowInvoiceSettings(false);

    if (!updatedTrust) {
      getTrusts();
      return;
    }

    setTrust(updatedTrust);
    setTrusts((currentTrusts) =>
      currentTrusts.map((currentTrust) =>
        currentTrust.id === updatedTrust.id ? updatedTrust : currentTrust,
      ),
    );
  };

  const displayValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return value;
  };

  const trustDetails = (t) => {
    const addressParts = t?.address ? t.address.split(",") : [];

    return (
      <Card
        className="mb-3 w-auto"
        style={{
          width: "fit-content",
          display: "inline-block",
          cursor: isAdminRole(userRole) ? "pointer" : "default",
        }}
        onClick={() => {
          if (isAdminRole(userRole)) setShowInvoiceSettings(true);
        }}
      >
        <Card.Body>
          <Card.Title> {t?.name}</Card.Title>
          <Card.Text>
            <ul className={"list-unstyled"}>
              <li>
                <BsGeoAltFill className={"me-2"} />
                {addressParts.map((part, i) => (
                  <span className={i === 0 ? "" : "ps-4"} key={i}>
                    {part.trim()}
                    {i < addressParts.length - 1 && (
                      <>
                        ,<br />
                      </>
                    )}
                  </span>
                ))}
              </li>
              <li>
                <BsEnvelopeFill className={"me-2"} /> {t?.email}
              </li>
              <li>
                <BsTelephoneFill className={"me-2"} /> {t?.phone}
              </li>
              {isAdminRole(userRole) && (
                <Fragment>
                  <li className={"mt-3"}>
                    <BsCashCoin className={"me-2"} />
                    <strong>Sage</strong>
                  </li>
                  <li className={"ps-4"}>
                    Account Reference: {displayValue(t?.sageAccountReference)}
                  </li>
                  <li className={"ps-4"}>
                    Nominal Code: {displayValue(t?.sageNominalCode)}
                  </li>
                  <li className={"ps-4"}>
                    Department Code: {displayValue(t?.sageDepartmentCode)}
                  </li>
                  <li className={"ps-4"}>
                    VAT Code: {displayValue(t?.sageVatCode)}
                  </li>
                  <li className={"ps-4"}>VAT: {displayValue(t?.sageVat)}</li>
                </Fragment>
              )}
            </ul>
          </Card.Text>
        </Card.Body>
      </Card>
    );
  };

  return (
    <Fragment>
      <Row className={"icon-text-wrapper"}>
        <PageTitleController
          title={"Facilities"}
          icon={<BsBuildingFillAdd className={"icon-right-spacing"} />}
        />
        <Col>
          <Container>
            <Row xs={"auto"} className={"justify-content-end"}>
              <Button
                variant="offblack"
                onClick={() => {
                  setFacility(null);
                  setShowAddFacilityModel(true);
                }}
              >
                + New Facility
              </Button>
            </Row>
          </Container>
        </Col>
      </Row>

      <Tabs
        id="shifts-table-tabs"
        onSelect={(k) => {
          setTrust(trusts[k - 1]);
          setFacility(null);
        }}
        className="mb-3"
      >
        {trusts?.map((trust, index) => (
          <Tab
            key={trust?.id}
            eventKey={trust?.id}
            title={trust?.shortName}
          ></Tab>
        ))}
      </Tabs>

      {trust && trustDetails(trust)}

      {SpinnerOrData(loading)}

      {trust && isAdminRole(userRole) && showInvoiceSettings && (
        <TrustInvoiceSettingsModal
          visible={showInvoiceSettings}
          close={() => setShowInvoiceSettings(false)}
          trust={trust}
          onComplete={updateTrustSettings}
        />
      )}

      {trust && showAddFacilityModel && (
        <AddEditFacilityModal
          key={trust?.id}
          trust={trust}
          close={() => setShowAddFacilityModel(false)}
          onComplete={() => {
            setShowAddFacilityModel(false);
            getFacilities();
          }}
          facility={facility}
          visible={showAddFacilityModel}
        />
      )}
    </Fragment>
  );
};

export default DisplayFacilities;
